import axios from "axios";
import { clearAuthStorage, safeGetAuthToken } from "../Helpers/authStorage";
import { refreshAccessToken } from "../_API/axiosConfig";
import useResilientEventSource from "./useResilientEventSource";

export const handleNotifyMessage = (ev) => {
  try {
    const msg = JSON.parse(ev.data); // { type, payload }
    if (!msg?.type) return;
    // Fix jobs-polling-y-toast-sse (aprobado): el handshake de
    // conexión/reconexión SSE (bot/sse.py) no es una notificación
    // para el usuario -- se filtra por TYPE, nunca por el contenido
    // del mensaje (antipatrón en este proyecto). La reconexión pasa
    // cada ~20s por diseño del backend (Paso 0), así que sin este
    // filtro el toast "Aviso" se repetía indefinidamente.
    const isHandshake =
      msg.type === "sse-hello" ||
      // TODO(jobs-polling-y-toast-sse): sacar esta rama cuando el
      // backend con bot/sse.py mandando type='sse-hello' esté
      // desplegado -- mientras tanto, un worker viejo puede seguir
      // mandando el handshake como type='notify'.
      (msg.type === "notify" && msg.payload?.message === "sse-connected");
    if (isHandshake) return;
    window.dispatchEvent(new CustomEvent(String(msg.type), { detail: msg.payload }));
  } catch {}
};

/**
 * SSE de notificaciones del panel (/api/notify/stream): reenvía cada mensaje
 * como evento de window ("zip-finished", "notify"...).
 * URL absoluta al API: la relativa en la app nativa apuntaba a capacitor://localhost.
 */
export default function useAdminNotifyStream(authToken) {
  return useResilientEventSource({
    enabled: Boolean(authToken),
    connectionKey: "admin-notify",
    getToken: () => safeGetAuthToken()?.token || authToken,
    refreshToken: refreshAccessToken,
    onAuthExpired: async () => {
      try {
        await clearAuthStorage();
      } catch (error) {
        console.warn("[auth] clearAuthStorage failed on expired SSE session", error);
      }
      window.location.href = "/";
    },
    buildUrl: (token) =>
      `${axios.defaults.baseURL || ""}/api/notify/stream?token=${encodeURIComponent(token)}`,
    handlers: { message: handleNotifyMessage },
  });
}
